"use client";

import * as images from "@/components/images/Images";
import React from "react";
import { Typography } from "@/components/ui/typography";
import IndustryCardsCarousel, {
  IndustryCard,
} from "@/components/screen/global-components/industry/IndustryCardsCarousel";

const industryCards: IndustryCard[] = [
  {
    title: "Education",
    description:
      "Specialized translations for educational reports, academic documents, and instructional materials, ensuring accuracy, clarity, and compliance with educational standards.",
    imageUrl: images.img1,
    link: "/use-cases/academic",
  },
  {
    title: "Finance",
    description:
      "Specialized translations for financial reports, statements, and documents that maintain technical integrity, and regulatory precision.",
    imageUrl: images.img2,
    link: "/use-cases/financial",
  },
  {
    title: "Government",
    description:
      "Specialized translations for official documents, policies, and reports, ensuring accuracy, clarity, and compliance with regulatory standards.",
    imageUrl: images.img3,
    link: "/industries/government",
  },
  {
    title: "Healthcare",
    description:
      "Expert translations for medical records, research papers, and patient documents, maintaining precision, confidentiality, and adherence to healthcare regulations.",
    imageUrl: images.img4,
    link: "/use-cases/medical",
  },
  {
    title: "Law",
    description:
      "Professional translations for legal contracts, court documents, and compliance materials, ensuring accuracy, technical integrity, and alignment with legal standards.",
    imageUrl: images.img5,
    link: "/use-cases/legal",
  },
  {
    title: "Explore industries",
    imageUrl: images.explore,
    link: "/industries",
    isStatic: true,
  },
];

export default function IndustryBlock() {
  const cardStatic = industryCards?.find((card) => card?.isStatic);
  return (
    <section className="section overflow-hidden">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8">
          <Typography variant="heading4">
            <h2>Translators specialized in your industry</h2>
          </Typography>
          <Typography variant="subHeadingSm" className="text-gray-600" asChild>
            <p>
              Never worry about speaking your customers' language. We’ll pair
              you with a translator fluent in your language pairing and with
              experience in your industry.
            </p>
          </Typography>
        </div>
        <IndustryCardsCarousel
          cards={industryCards}
          className="mt-6 lg:!mt-12"
        />
      </div>
    </section>
  );
}
